export default {
  基本資訊: {
    行事曆: "hrMainPage/calendar",
    公司資訊: "hrMainPage/companyInfo",
    編輯公司資訊: "hrMainPage/editCompanyInfo",
    員工管理: "hrMainPage/employees",
    員工管理系統: "hrMainPage/employees",
    新增員工: "hrMainPage/addEmployee",
    編輯員工: "hrMainPage/editEmployee",
    新增部門: "hrMainPage/addDepartment",
    部門管理: "hrMainPage/department",
    訂閱方案: "hrMainPage/subscribe",
    戰情室: "hrMainPage/warRoom",
  },
  商品: {
    商品管理: "hrMainPage/product",
    新增商品: "hrMainPage/addProduct",
    品項編輯器: "hrMainPage/itemEditor",
  },
  倉儲: {
    倉庫與儲位管理: "hrMainPage/warehouse",
    進出貨歷程: "hrMainPage/stockHistory",
    倉儲管理系統: "hrMainPage/warehouseSystem",
    新增倉庫: "hrMainPage/addWarehouse",
    入庫單管理: {
      入庫單管理已建立: "hrMainPage/inventoryCreated",
      建立入庫單: "hrMainPage/addInventoryCreated",
      入庫單管理已完成: "hrMainPage/inventoryDone",
    },
    領料單管理: {
      領料單管理已建立: "hrMainPage/stockRequestCreated",
      領料單管理已完成: "hrMainPage/stockRequestDone",
    },
  },
  合作方: {
    合作方列表: "hrMainPage/coop",
    新增合作方: "hrMainPage/addCoop",
    審核中: "hrMainPage/coopPending",
    已停用: "hrMainPage/coopReviewed",
  },
  專案管理: {
    專案列表: "hrMainPage/projectQuotation",
    已封存: "hrMainPage/projectQuotationArchived",
    新增專案列表: "hrMainPage/addProjectQuotation",
    編輯專案列表: "hrMainPage/editQuotation",
    專案列表顯示: "hrMainPage/quotationPage",
  },
  財務: {
    "應收帳款(客戶)": "hrMainPage/accountReceivable",
    "應付帳款(供應商/信用卡/個人)": "hrMainPage/accountPayable",
    銀行: "hrMainPage/bank",
  },
  採購: {
    採購單: {
      新增採購單: "hrMainPage/addPurchaseOrder",
      編輯採購單: "hrMainPage/editPurchaseOrder",
      採購單草稿: "hrMainPage/purchaseOrderDraft",
      採購單審核中: "hrMainPage/purchaseOrderUnderReview",
      採購單已審核: "hrMainPage/purchaseOrderApproved",
      採購單已完成: "hrMainPage/purchaseOrderCompleted",
    },
    詢價單: {
      詢價單草稿: "hrMainPage/rfqDraft",
      詢價單審核中: "hrMainPage/rfqUnderReview",
      詢價單已完成: "hrMainPage/rfqCompleted",
    },
    // 拖外加工單: {
    //   草稿: 'hrMainPage/purchaseOrder/draft',
    //   審核中: 'hrMainPage/purchaseOrder/underReview',
    //   已審核: 'hrMainPage/purchaseOrder/approved',
    //   已完成: 'hrMainPage/purchaseOrder/completed',
    // },
    檢驗單: {},
    退貨單: {},
  },
};
